import Splide from '@splidejs/splide';

const carouselI18n = {
  prev: 'Slide precedente',
  next: 'Slide successiva',
  first: 'Vai alla prima slide',
  last: 'Vai all’ultima slide',
  slideX: 'Vai alla slide %s',
  pageX: 'Vai a pagina %s',
  play: 'Attiva autoplay',
  pause: 'Pausa autoplay',
  carousel: 'carosello',
  select: 'Seleziona una slide da mostrare',
  slide: 'slide',
  slideLabel: '%s di %s',
};

const carouselConfigs = {
  '.js-stage-carousel--offers': {
    perPage: 4,
    perMove: 1,
    gap: '0.25rem',
    pagination: true,
    arrows: true,
    breakpoints: {
      1200: { perPage: 4 },
      992: { perPage: 3 },
      768: { perPage: 2 },
      576: { perPage: 1 },
    },
  },
  '.js-stage-carousel--bandi': {
    perPage: 3,
    perMove: 1,
    gap: '0.25rem',
    pagination: true,
    arrows: true,
    breakpoints: {
      992: { perPage: 2 },
      576: { perPage: 1 },
    },
  },
  '.js-stage-carousel--eventi': {
    perPage: 1,
    perMove: 1,
    gap: '0rem',
    pagination: true,
    arrows: true,
  },
};

const baseCarouselOptions = {
  type: 'slide',
  rewind: false,
  speed: 650,
  drag: true,
  autoplay: false,
  keyboard: true,
  updateOnMove: true,
  trimSpace: false,
  mediaQuery: 'max',
  i18n: carouselI18n,
};

export const initCarousels = () => {
  Object.entries(carouselConfigs).forEach(([selector, config]) => {
    document.querySelectorAll(selector).forEach((carouselElement) => {
      if (carouselElement.dataset.splideMounted === 'true') {
        return;
      }

      const splide = new Splide(carouselElement, {
        ...baseCarouselOptions,
        ...config,
      });

      splide.mount();
      carouselElement.dataset.splideMounted = 'true';
    });
  });
};